<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">网格信息维护&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>网格机构管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="类型">
                <el-select
                  filterable
                  placeholder="请选择类型"
                  clearable
                  v-model="form.publicServiceType"
                >
                  <el-option
                    v-for="item in publicServiceTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="名称">
                <el-input
                  v-model="form.name"
                  clearable
                  placeholder="请输入名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="请选择所属社区"
                  clearable
                  v-model="form.communityCode"
                  @change="commcommunityChange"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="请选择所属网格"
                  clearable
                  v-model="form.blockCode"
                >
                  <el-option
                    v-for="item in blockList"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="请选择所属网格"
                  clearable
                  v-model="form.enableStatus"
                >
                  <el-option
                    v-for="item in openFlagOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="所属城中村小区">
                <el-input
                  v-model="form.villagesInCity"
                  clearable
                  placeholder="请输入所属城中村小区"
                ></el-input>
              </el-form-item>
              <el-form-item label="展示状态">
                <el-select
                  filterable
                  placeholder="请选择启用状态"
                  clearable
                  v-model="form.isFrontDisplayed"
                >
                  <el-option
                    v-for="item in isFrontDisplayedOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:isFrontDisplayed="{ scope }">
            <el-switch
              @change="
                value => {
                  updateBlockOrganizationFun(value, scope.row);
                }
              "
              v-model="scope.row.isFrontDisplayed"
              active-value="0"
              inactive-value="1"
              active-color="#0495FF"
            >
            </el-switch>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >编辑</el-button
            >
            <el-button
              @click="delBlockOrganizationFun([scope.row.id])"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="getBlockOrganizationListPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  getBlockOrganizationListPage,
  delBlockOrganization,
  updateBlockOrganization
} from "@/api/block.js";
import { downloadFile } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import index from "./index";
export default {
  components: {
    addDialog,
    commonTable
  },
  mixins: [index],
  data() {
    return {
      form: {
        publicServiceType: "",
        name: "",
        communityCode: "",
        blockCode: "",
        villagesInCity: "",
        isFrontDisplayed: "",
      },
      isFrontDisplayedOptions: [
        {
          label: "展示",
          value: 0
        },
        {
          label: "不展示",
          value: 1
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pubilcServiceTypeName",
            label: "类型"
          },
          {
            prop: "name",
            label: "名称"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          },
          {
            prop: "levelName3",
            label: "所属网格"
          },
          {
            prop: "grid",
            label: "所属网格"
          },
          {
            prop: "villagesInCity",
            label: "所属小区/城中村"
          },
          {
            slot: "isFrontDisplayed",
            label: "是否前台展示"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {}
    };
  },
  mounted() {
    this.getBlockOrganizationListPageFun();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getBlockOrganizationListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getBlockOrganizationListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getBlockOrganizationListPageFun();
    },
    onReset() {
      this.form.publicServiceType = "";
      this.form.name = "";
      this.form.communityCode = "";
      this.form.blockCode = "";
      this.form.villagesInCity = "";
      this.form.isFrontDisplayed = "";
      this.page.page = 1;
      this.page.size = 10;
      this.getBlockOrganizationListPageFun();
    },
    // 开启关闭
    async updateBlockOrganizationFun(value, item) {
      let params = {
        isFrontDisplayed: value,
        id: item.id
      };
      const res = await updateBlockOrganization(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.getBlockOrganizationListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 删除
    async delBlockOrganizationFun(delList) {
      let params = {
        delList: delList
      };
      const res = await delBlockOrganization(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async getBlockOrganizationListPageFun() {
      let params = {
        publicServiceType: this.form.publicServiceType,
        name: this.form.name,
        communityCode: this.form.communityCode,
        blockCode: this.form.blockCode,
        villagesInCity: this.form.villagesInCity,
        isFrontDisplayed: this.form.isFrontDisplayed,
        page: this.page.page,
        size: this.page.size
      };
      const res = await getBlockOrganizationListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/streetInfo/blockOrganization/index.vue